import React from "react";
import LogoAHOH from "../../images/logo-ahoh.png";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { setPopupComponent } from "../../store/slices/ui";

function BrandingFooter() {
  const dispatch = useDispatch();
  return (
    <div className=" ">
      <div className="footer-logo ">
        <span className="popup-link">
          <a
            href="#"
            className="text-xs"
            onClick={() => dispatch(setPopupComponent("TermsCondition"))}
          >
            <i>terms & conditions</i>{" "}
          </a>
          <br />
          <a
            href="#"
            className="text-xs"
            onClick={() => dispatch(setPopupComponent("PrivacyPolicy"))}
          >
            <i>privacy policy</i>
          </a>
        </span>

        <span className={classNames("text-right ml-auto")}>
          <a href="https://adohscientific.com/" target="_blank">
            <i className="text-xs font-bold text-gray-400">powered by</i>
            <img src={LogoAHOH} alt="" />
          </a>
        </span>
      </div>
    </div>
  );
}

export default BrandingFooter;
